<template>
  <div class="page">
    <div class="title">
      <div class="top">
        <div class="top-item">卡号</div>
        <div class="top-items">{{ recordLoginText }}</div>
      </div>
      <div class="yuer"> ￥{{ simInfo.depositPrice }}</div>
      <div class="smallyue">合约余额</div>
      <!-- <div class="cz" @click="toRecharge">充值本卡</div> -->
      <div class="bot">
        <div class="bot-left">
          <div>合约有效时间</div>
          <div>{{ simInfo.depositTimeFormat }}</div>
        </div>
      </div>
      <div class="bot">
        <div class="bot-left">
          <div>自动退费时间</div>
          <div>{{ simInfo.depositTimeFormat }}</div>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <div class="u-form">
      <div class="name">温馨提示</div>
      <div class="tip1" style="margin-top:30upx;">1：畅享流量尊享版(39.9元档)促销产品是以畅享流量尊享版(39.9元档)为主体产品，需办理12个月合约产品畅享流量尊享版(39.9元档)-12个月合约，合约优惠包含300GB全国通用流量和每月20元套餐月费减免。套餐内全国通用流量全量提供，该合约资费有效期365天，合约到期后余额自动退回。</div>
      <div class="tip1">2：畅享流量尊享版(39.9元档)套餐内包含300GB全国通用流量月包（30天有效期），全国通用流量范围包括中国移动精品APP及阿里系、百度系、抖音系、网易游戏、腾讯系、芒果TV、快手、喜马拉雅、新浪微博、VIVO等超过100款第三方热门APP。具体支持全国通用流量的APP清单随中国移动业务合作情况或将发生变动，以订购页面具体内容为准。</div>
      <div class="tip1">3：激活时连带办理合约活动畅享流量尊享版(39.9元档)-12个月合约，办理当月立即生效，合约期12个月，合约期内每月包含300G通用流量，流量不可结转、不可共享、不可转赠，另合约期内每月优惠20元套餐费用，合约到期后优惠政策自动顺延。合约期12个月内需使用畅享流量尊享版(39.9元档)，提前取消合约或更改套餐后，将无法享受相关活动优惠。提前退出合约可联系人工客服在线办理。</div>
      <div class="tip1">4：畅享流量尊享版(39.9元档)-12个月合约期，若中途违约/取消合约，系统将之前所有优惠套餐20元/月扣除。且后续订购套餐将不能享受每月优惠20元的价格以及赠送的流量包，将原价订购套餐，若有其它疑问，请联系客服咨询,最终解释权归本司所有。</div>
    </div>
    <br/>
    <br/>
    <van-button type="primary" round block color="#397EF5" @click="toKefu()" class="footer-btn">联系客服</van-button>
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      userAccount: {},
      simInfo: {},
      recordLoginText: localStorage.getItem('recordLoginText'),
      iccid: localStorage.getItem('iccid'),
    }
  },
  created() {
    this.getAccount();
    this.getInfo();
  },
  methods: {
    toKefu(){
      window.location.href = 'http://kefu.szxxtx.com/s/135302p4tv'
    },
    toRecharge() {
      this.$router.replace('/newUser/recharge')
    },
    detailsTo() {
      this.$router.push({
        path: '/newUser/coupon',
        query: {
          iccid: this.iccid
        }
      })
    },
    getAccount() {
      const param = {
        iccid: this.iccid,
        mobile: localStorage.getItem('mobile')
      }
      // 若为总部微信公众号
      if (localStorage.getItem('isHeadquarterAppid')) {
        wxRequest('/sysUser/account/querySysUserAccount', param, 'post').then(
          (res) => {
            if (res.data.code === '200') {
              this.userAccount = res.data.data
              this.alreadyHasAccount = true
            } else if (res.data.code === '400') {
              const self = this
              if (self.$store.state.supplierCode === '1197749413972275200') {
                Dialog.confirm({
                  title: '提示',
                  message: '首次使用需进行充值，请点击【确认】前往充值'
                })
                  .then(() => {
                    self.$router.replace('/newUser/recharge')
                  })
                  .catch(() => { })
              }
            }
          }
        )
      } else {
        // 若为代理商公众号
        wxRequest('/sysUser/account/querySysUserAccount', param, 'post').then(
          (res) => {
            if (res.data.code === '200') {
              this.userAccount = res.data.data
              this.alreadyHasAccount = true
            }
          }
        )
      }
    },
    getInfo() {
      wxRequest('sim/detail', { iccid: this.iccid }, 'post').then((res) => {
        if (res.data.code === '200') {
          this.simInfo = res.data.data
        } else {
          Toast.fail(res.data.message)
        }
      })
    },


  }
}
</script>

<style lang="less" scoped>
.page {
  padding: 0 13px;
  background: linear-gradient(180deg, #3980F9 0%, rgba(244, 246, 250, 1) 240px);
  height: calc(100% - 21px);
  padding-top: 21px;
  position: relative;

  .u-form {
    width: calc(90% - 14px);
    padding: 25px 14px;
    margin: 23px auto;
    background: #fff;
    border-radius: 10px;

    .name {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #28292D;
      line-height: 20px;
    }

    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #63666D;
      margin-top: 9px;
      margin-bottom: 20px;
    }

    img {
      width: 358px;
      height: 118px;
    }

    .u-input {
      margin-top: 49px;
      border-bottom: 1px solid #F3F3F3;
    }

    .tip1 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #63666D;
      text-indent: 28px;
      margin: 10px 0;
      line-height: 20px;
    }
  }

  .title {
    width: 350px;
    height: 300px;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 0 auto;
    position: relative;


    .top {
      display: flex;
      height: 57px;
      padding-left: 11px;
      align-items: center;
      background: linear-gradient(180deg, #B1CEFF 0%, #FFFFFF 100%);
      border-radius: 10px 10px 0px 0px;

      .top-item {
        font-size: 12px;
        font-family: HarmonyOS_Sans_SC;
        color: #FFFFFF;
        text-align: center;
        line-height: 17px;
        width: 62px;
        background: url('./../../../assets/new/newCopy/icon12.png') no-repeat center;
        background-size: 100% 100%;
      }

      .top-items {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #28292D;
        line-height: 22px;
        padding-left: 10px;
      }
    }

    .yuer {
      height: 50px;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #28292D;
      text-align: center;
      line-height: 50px;
      margin-top: 36px;
    }

    .smallyue {
      text-align: center;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }

    .cz {
      width: 88px;
      height: 31px;
      background: url('../../../assets/new/newCopy/icon13.png') no-repeat center;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 40%;
      text-align: center;
      line-height: 30px;
      color: #fff;
    }

    .bot {
      width: 88%;
      margin: 27px auto 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #F3F3F3;
      padding-top: 14px;
      .bot-left{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }
      .bot-right {
        color: #397FF9;
      }
    }
  }

  .img {
    width: 96%;
    height: 90px;
    margin: 20px auto;
    display: block;
  }
}
.footer-btn{
  position: fixed;
  bottom:20px;
  left: 0;
  right: 0;
  margin: auto;
  width:90%;
}
</style>